import { ReactElement, memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import PopupDialog from "../../../components/elements/PopupDialog/PopupDialog";
import RemoveCartItemMessage from "./RemoveCartItemMessage";
import "./RemoveCartItemModal.scss";
import "./RemoveCartItemModal_flint.scss";
import "./RemoveCartItemModal_kokoro.scss";
import "./RemoveCartItemModal_pdd.scss";
import "./RemoveCartItemModal_shabuDays.scss";
import "./RemoveCartItemModal_torikizoku.scss";
import "./RemoveCartItemModal_wang.scss";
import { useRemoveCartItem } from "./useRemoveCartItem";

const RemoveCartItemModal = (): ReactElement => {
	const { isOpen, cancelRemove, confirmRemove, item } = useRemoveCartItem();

	const { t } = useTranslation();

	const buttons = useMemo(
		() => [
			{
				text: t("cartPage.noKeepItem"),
				onClick: cancelRemove,
				className: "BtnRemoveItemCancel",
			},
			{
				text: t("cartPage.yesRemoveItem"),
				onClick: confirmRemove,
				className: "BtnRemoveItemConfirm",
			},
		],
		[t, cancelRemove, confirmRemove]
	);

	return (
		<PopupDialog
			open={isOpen}
			onClose={cancelRemove}
			content={<RemoveCartItemMessage item={item} />}
			buttons={buttons}
			data-testid="RemoveItemModal"
			className="RemoveItemModal"
		/>
	);
};

export default memo(RemoveCartItemModal);
